module.exports = __webpack_public_path__ + "img/close-white-icon.4f4fc605.svg";